import { render, staticRenderFns } from "./EditableRectAvatar.vue?vue&type=template&id=1aa98d3c&scoped=true"
import script from "./EditableRectAvatar.vue?vue&type=script&lang=js"
export * from "./EditableRectAvatar.vue?vue&type=script&lang=js"
import style0 from "./EditableRectAvatar.vue?vue&type=style&index=0&id=1aa98d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa98d3c",
  null
  
)

export default component.exports